import { render, staticRenderFns } from "./messageConfig.vue?vue&type=template&id=3f46ed49&scoped=true"
import script from "./messageConfig.vue?vue&type=script&lang=js"
export * from "./messageConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f46ed49",
  null
  
)

export default component.exports